<template v-cloak>
    <NuxtLayout :class="css.container" name="main">
        <!-- * 辅助信息 -->
        <helper />

        <section
            :class="css.header"
            class="bg-[url('https://rdgta.cdn.cyagen.com/rddc/pictures/ddc03a46-3dd9-4c9c-a4c6-f7b761543c50.webp')] bg-no-repeat bg-cover w-[100%] pt-[80px] pb-[88px] max-xl:pt-[48px] max-xl:pb-[56px] max-lg:pb-[40px]">
            <div class="container">
                <!-- * 搜索框标题 -->
                <h1 class="font-bold text-center text-[#fec300] text-[56px] leading-[88px] max-lg:text-[44px] max-lg:leading-[76px]">
                    Rare Disease Data Center
                </h1>
                <div class="text-center text-white leading-[32px]">{{ $t("Module1Descript") }}</div>
                <!-- * 搜索框 -->
                <div class="mx-auto mt-[40px] mb-[24px] max-xl:mt-[32px] max-xl:mb-[16px] w-[1008px] max-xl:w-[992px] max-lg:w-[944px]">
                    <select-search v-model="keyword" @search="methods.search"></select-search>
                </div>

                <!-- * 热门搜索列表 -->
                <div :class="css.hots" class="flex-center" v-if="list && list.length">
                    <template v-for="(value, index) in list" :key="index">
                        <project-route
                            :class="css.hot"
                            class="ellipsis text-white leading-[32px] mx-[8px] hover:underline hover:underline-offset-4 hover:text-white visited:text-white"
                            :to="methods.route(value)"
                            :title="value.value">
                            {{ value.value }}
                        </project-route>
                    </template>
                </div>

                <!-- * 统计数据 -->
                <div class="flex-center mt-[48px] max-xl:mt-[32px]">
                    <template v-for="(value, index) in options.statistics" :key="index">
                        <div v-if="index > 0" class="bg-uicolor4 w-[2px] h-[64px] mx-[76px] max-xl:mx-[60px] max-lg:mx-[42px]"></div>
                        <h2 ref="statistic">
                            <project-route class="text-center inline-block" :to="{ name: value.route }">
                                <div class="text-nowrap font-bold text-white text-[48px] leading-[70px] max-xl:text-[44px] max-xl:leading-[64px]">
                                    <number-animation :decimals="value?.decimals || 0" :max="value.count" :unit="value?.unit || ''" />
                                    <p ref="max" class="opacity-0 h-0">{{ value.count.toFixed(value.decimals).toString() + (value.unit || "") }}</p>
                                </div>
                                <div class="font-bold text-white text-[20px] leading-[28px]">{{ value.name }}</div>
                            </project-route>
                        </h2>
                    </template>
                </div>
            </div>
        </section>

        <!-- * 推荐工具 -->
        <section :class="css.module" class="container pt-[96px] max-xl:pt-[64px] max-lg:pt-[48px]">
            <h2 :class="css.title" class="font-bold text-emphas text-[30px] leading-[46px]">{{ $t("RecommandedTools") }}</h2>
            <ui-carousel-multiple-view :pagination="true" arrow="never" :class="css.tools" class="flex" ref="carousel">
                <project-route
                    :class="css.tool"
                    class="flex flex-col overflow-hidden border border-solid border-uicolor4/50 rounded-[8px] w-[290px] max-xl:w-[250px] max-lg:w-[270px] hover:border-main"
                    v-for="(value, _key) in options.tools"
                    :to="value.route">
                    <img class="w-[100%]" :src="value.img" :alt="value.name" />
                    <div :class="css.info" class="p-[16px] pb-[24px] flex-1">
                        <h3 class="font-bold text-emphas text-[20px] leading-[36px] max-xl:text-[18px] max-xl:leading-[28px]">{{ value.name }}</h3>
                        <div class="text-emphas mt-[8px] leading-[24px]">
                            {{ value.descript }}
                        </div>
                    </div>
                </project-route>
            </ui-carousel-multiple-view>
            <!-- * 分页器 -->
            <div class="mt-[24px] flex-center" v-if="pagination > 1">
                <div
                    v-for="(_num, key) in pagination"
                    :class="[css.pagination, key == current && css.active]"
                    class="cursor-pointer mx-[6px] size-[12px] rounded-[50%] bg-[#000000]/50"
                    @click="methods.switch(key)"></div>
            </div>
        </section>

        <!-- * 特色 -->
        <section :class="css.module" class="container pt-[96px] max-xl:pt-[80px] max-lg:pt-[76px]">
            <h2 :class="css.title" class="font-bold text-emphas text-[30px] leading-[46px]">
                {{ $t("Home.Module3Name") }}
                <p v-if="$i18n.locale == 'en'">Advanced Data Visualization</p>
            </h2>
            <div>{{ $t("Home.Module3Descript1") }}</div>
            <div class="mt-[16px]">{{ $t("Home.Module3Descript2") }}</div>
            <div class="mt-[24px] flex justify-between">
                <project-route
                    v-for="(value, index) in options.features"
                    :to="value.route"
                    :key="value.name"
                    target="_blank"
                    class="flex flex-col p-[32px] rounded-[8px] w-[368px] max-xl:w-[320px] max-lg:w-[272px] visited:text-white hover:text-white"
                    :style="`background: ${value.background}`">
                    <img class="size-[48px]" :src="value.icon" alt="icon" />
                    <h3 class="mt-[16px] font-bold text-[20px] leading-[28px] text-uicolor5">{{ value.name }}</h3>
                    <div class="flex-1 my-[8px] text-white line-clamp-3">{{ value.descript }}</div>
                    <div class="text-white inline-flex items-center cursor-pointer">
                        <span class="underline underline-offset-4"> {{ $t("More") }}</span>
                        <ui-icon name="arrow" class="text-[12px] mt-[4px] ml-[4px]" style="transform: rotate(270deg)" />
                    </div>
                </project-route>
            </div>
        </section>

        <!-- * 资讯动态 -->
        <section
            :class="css.module"
            class="container pt-[120px] max-xl:pt-[98px] max-lg:pt-[96px]"
            v-if="data && (data.news.length || data.carousels.length)">
            <h2 :class="css.title" class="font-bold text-emphas text-[30px] leading-[46px]">{{ $t("Home.Module5Name") }}</h2>
            <div :class="css.news" class="flex items-stretch">
                <div class="mb-[16px] shrink-0 w-[752px] max-xl:w-[648px] max-lg:w-[560px]">
                    <ui-carousel :pagination="true" arrow="never" :delay="5000" class="rounded-[8px] overflow-hidden" v-if="data.carousels.length">
                        <project-route class="relative overflow-hidden block" v-for="value in data.carousels" :to="value.url">
                            <img
                                class="absolute left-1/2 top-1/2 max-xl:w-[96px] max-xl:h-[96px]"
                                style="transform: translate(-50%, -50%)"
                                src="https://rdgta.cdn.cyagen.com/rddc/images/play.webp" />
                            <img class="w-[100%] h-[100%] object-cover" :src="value.cover" :alt="value.title" />
                            <div
                                class="px-[16px] py-[12px] w-[100%] absolute bottom-0 left-0 bg-gradient-to-b from-[transparent] from-0% to-[#00000080] to-100%">
                                <div class="ellipsis font-bold text-white text-[20px] leading-[36px]">{{ value.title }}</div>
                                <div class="text-white">{{ value.date }}</div>
                            </div>
                        </project-route>
                    </ui-carousel>
                </div>

                <div class="flex flex-wrap" v-if="data.news.length">
                    <project-route
                        class="ml-[16px] mb-[16px] overflow-hidden border border-solid border-uicolor4/50 rounded-[8px] w-[368px] max-xl:w-[320px] max-lg:w-[272px] hover:border-main"
                        v-for="(value, index) in data.news"
                        :to="value.url">
                        <div class="relative h-[200px] max-xl:h-[174px] max-lg:h-[148px]">
                            <img class="object-cover w-full h-full" :src="value.cover_src" :alt="value.cover_alt" />
                            <div class="absolute top-0 left-0 w-full h-full p-[20px] max-xl:py-[12px]" v-if="value.labels?.length">
                                <div v-for="_ in value.labels" v-html="_" class="text-white font-bold text-[18px] max-xl:text-[16px]"></div>
                            </div>
                        </div>
                        <div class="px-[16px] py-[12px] max-lg:py-[8px]">
                            <div class="ellipsis font-semibold text-[16px] text-emphas">{{ value.title }}</div>
                            <div class="text-default">{{ value.send_date }}</div>
                        </div>
                    </project-route>
                </div>
            </div>
        </section>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiCarouselMultipleView, UiCarousel, UiIcon } from "various-ui";
//* 公共组件引入
import { Helper } from "@/components/complete";
import { SelectSearch } from "@/components/controls";

//* 私有组件
import NumberAnimation from "./components/NumberAnimation.vue";

//* 组合函数
import { useComposable } from "./src/composable";
import type { HomeData, HotSearchData } from "./src/types";
//* 样式
import css from "./index.module.less";

//* 数据初始化
const data: Ref<HomeData> = await api.server("Home", "/api/v1/home");
//* 获取热门搜索列表
const list: Ref<HotSearchData[]> = await api.server("HomeHots", "/api/v1/home/hots");

//* 组合函数
const { variable, options, refs, nodes, methods } = useComposable(data);
const { keyword, current, pagination } = refs;
const { statistic, carousel } = nodes;

//* 组件挂载后
onMounted(() => {
    variable.observer = useResizeWObserver(document.body, methods.resize);
});

//* 组件卸载后
onBeforeUnmount(() => {
    variable.observer?.disconnect();
});
</script>
